import React from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';

function AddDiscountItems(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'discountOn', headerName: 'Discount On', width: 200 },
        { field: 'TypeOfDiscount', headerName: 'Type Of Discount', width: 200 },
        { field: 'Amount', headerName: 'Amount', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', discountOn: 'Section', TypeOfDiscount: "Exact Amount", Amount: '10' },
        { id: 2, checkbox: '', discountOn: 'Menu', TypeOfDiscount: "Percentage", Amount: '10%' },
        { id: 3, checkbox: '', discountOn: 'Item', TypeOfDiscount: "Percentage", Amount: '10%' },
    ];
    return (
        <div>
            <div>
                <FilterComponents title={"OK"} isItem={4} />
                <CustomDataGrid columns={columns} dataRows={dataRows} />
            </div>
        </div>
    );
}

export default AddDiscountItems;